// Reject model instructions and analysis, including artifacts already in history.
export function isWorkSummaryArtifact(text: string): boolean {
  return /<(?:think|analysis|reasoning)\b|```|\b(?:USER ASKED|ASSISTANT DID|TOOLS USED|FILES CHANGED|GIT BRANCH)\s*:|\bconstraint\s*\d+\s*:|\b(?:the user wants me to|summarize what the (?:AI|assistant)|write one sentence|exactly one sentence|no actual information about what the assistant)|^\s*\d+[.)]\s*\*?\*?(?:analy[sz]e|goal|constraint|reasoning)\b/i.test(text)
}

export function validateGeneratedWorkSummary(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const text = value.trim()
  if (!text || text.length > 500 || text.split(/\s+/).length > 120 || isWorkSummaryArtifact(text)) return null
  return text.replace(/\s+/g, ' ')
}

export const PENDING_WORK_SUMMARY = 'Activity recorded. Detailed summary pending; generation will retry on the next connector sync.'

export function displayWorkSummary(text: string | null | undefined): string {
  return !text || isWorkSummaryArtifact(text)
    ? 'Recorded coding activity (detailed summary unavailable)'
    : text
}
